module.exports = __webpack_public_path__ + "img/resource-3.f0594737.png";